import { Controller } from "@hotwired/stimulus"
import { apiJson, formatApiErrorDetail } from "../lib/api_errore"

// Dato di components/ControlliTecnici.js:31-77 (31a5bd1): un dato di un intervento con la sua evidenza. «Conferma» manda
// PUT /api/projects/:id/interventi-tecnici/:gid { codice, campo, valore, componente, evidenza: { tipo, riferimento } }
// con il valore come lo converte l'originale ("" → null, bool → true/false, mesi → Number); «Togli» lo stesso con il
// valore vuoto. Riuscito: il passo 4 si rilegge (onAggiorna = load, il turbo-frame che lo contiene) e l'evento
// "dato-tecnico:salvato"; un rifiuto: il testo dell'errore sotto la riga.
export default class extends Controller {
  static targets = ["valore", "componente", "evidenza", "riferimento", "errore"]
  static values = { url: String, codice: String, campo: String, tipo: String }

  conferma() {
    this.invia(this.valoreTarget.value)
  }

  togli() {
    this.invia("")
  }

  async invia(v) {
    this.mostraErrore("")
    const tipo = this.tipoValue
    const valore = v === "" ? null : tipo === "bool" ? v === "true" : tipo === "mesi" ? Number(v) : v
    const corpo = {
      codice: this.codiceValue, campo: this.campoValue, valore,
      componente: this.hasComponenteTarget ? this.componenteTarget.value : "",
      evidenza: { tipo: this.evidenzaTarget.value, riferimento: this.riferimentoTarget.value },
    }
    try {
      await apiJson(this.urlValue, { method: "PUT", body: corpo })
    } catch (e) {
      this.mostraErrore(formatApiErrorDetail(e.detail) || "Salvataggio non riuscito")
      return
    }
    this.dispatch("salvato", { detail: corpo })
    this.element.closest("turbo-frame")?.reload?.()
  }

  mostraErrore(testo) {
    this.erroreTarget.textContent = testo
    this.erroreTarget.hidden = !testo
  }
}
